module.exports = __webpack_public_path__ + "img/classify_10.0ed0d8f3.png";